import { normalizeAnalyticsId, runIsolatedAnalyticsTask, shouldEnableAnalytics } from '~/utils/analyticsGate';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const baiduId = normalizeAnalyticsId(config.public.baiduStatisticsId as string)
  const nodeEnv = process.env.NODE_ENV || ''

  // 仅在生产环境且配置了 ID 时加载统计代码
  if (!shouldEnableAnalytics({ id: baiduId, nodeEnv })) {
    return
  }

  runIsolatedAnalyticsTask(() => {
    // 初始化 _hmt 数组
    window._hmt = window._hmt || []

    // 注入百度统计脚本（去重）
    if (!document.getElementById('baidu_analytics')) {
      const script = document.createElement('script')
      script.src = `https://hm.baidu.com/hm.js?${baiduId}`
      script.id = 'baidu_analytics'
      script.async = true

      const s = document.getElementsByTagName('script')[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(script, s)
      } else {
        document.head.appendChild(script)
      }
    }
  })

  // 路由切换时上报 PV
  const router = useRouter()
  router.afterEach((to) => {
    runIsolatedAnalyticsTask(() => {
      if (!window._hmt) {
        return
      }
      window._hmt.push(['_trackPageview', to.fullPath])
    })
  })
})

